import axios from 'axios';
import config from '../../config';

const API_URL = config.API_URL; 

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export default axiosInstance;
